<template>
  <div>
    <VueChart
      :chart-type="chartType"
      :chart-data="value"
      :options="options"
      :style="myStyles"
    />
  </div>
</template>

<script>
import VueChart from '@/components/Chart'
import { humanize } from 'inflected'
export default {
  components: {
    VueChart
  },
  props: {
    value: {
      type: [ Array, Object ],
      required: true
    },
    chartType: {
      type: String,
      required: false,
      default: 'Line'
    },
    chartOptions: {
      type: Object,
      required: false,
      default: () => ({})
    },
    title: {
      type: String,
      required: false,
      default: 'Widget Title'
    },
    params: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data () {
    return {
      options: {
        title: {
          display: true,
          lineHeight: 1.6,
          padding: 5,
          text: [
            this.title,
            `${humanize(this.params.dateFrom)} - ${humanize(this.params.dateTo)}`
          ]
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            stacked: this.chartType === 'Bar',
            ticks: {
              display: this.chartType !== 'Pie'
            },
            gridLines: {
              display: this.chartType !== 'Pie'
            }
          }],
          yAxes: [{
            stacked: this.chartType === 'Bar',
            gridLines: {
              display: this.chartType !== 'Pie'
            },
            ticks: {
              // Include a dollar sign in the ticks
              callback: (value, index, values) => {
                if (this.chartType === 'Pie') {
                  return ''
                } else {
                  return `$${value}`
                }
              }
            }
          }]
        },
        tooltips: {
          enabled: true,
          mode: 'single',
          callbacks: {
            label: (tooltipItems, data) => {
              return `${data.labels[tooltipItems.index]}: ${this.$filters.currency(data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index])}`
            }
          }
        }
      }
    }
  },
  computed: {
    myStyles () {
      return {
        position: 'relative',
        height: '90%'
      }
    }
  },
  methods: {
    getDateRangeString (params) {
      return `${params.dateFrom || '-'} - ${params.dateTo || '-'}`
    }
  }
}
</script>
